// import PropTypes from 'prop-types'
import { useState } from 'react'

import Button from 'components/Button'
import Label from 'components/Label'
import RadioInputs from 'components/RadioInputs'
import SelectInput from 'components/SelectInput'

import { ApplyButton, OpenButton, RadioInputsWrapper, Root, SelectWrapper } from './ProductsSort.style'

const options = [
  { value: 'manual', label: 'Default' },
  { value: 'title|asc', label: 'A to Z' },
  { value: 'title|desc', label: 'Z to A' },
  { value: 'price|desc', label: 'Highest price' },
  { value: 'price|asc', label: 'Lowest price' },
  { value: 'published_at|desc', label: 'Newest' },
  { value: 'published_at|asc', label: 'Oldest' },
]

const ProductsSort = ({ value, onChange = () => {} }) => {
  const [open, setOpen] = useState(false)

  const valueOption = options.find((option) => option.value === value)

  const handleSelectChange = ({ value }) => onChange(value)
  const handleRadioChange = (value) => onChange(value)

  return (
    <Root>
      <OpenButton>
        <Button text="Sort" width="full" variant="outlined" onClick={() => setOpen(true)} />
      </OpenButton>
      <SelectWrapper>
        <Label text="Sort by">
          <SelectInput
            options={options}
            defaultValue={value || options[0]}
            value={valueOption}
            onChange={handleSelectChange}
          />
        </Label>
      </SelectWrapper>
      <RadioInputsWrapper $open={open}>
        <RadioInputs options={options} value={valueOption?.value} onChange={handleRadioChange} />
        <ApplyButton>
          <Button text="Apply" width="full" onClick={() => setOpen(false)} />
        </ApplyButton>
      </RadioInputsWrapper>
    </Root>
  )
}

ProductsSort.propTypes = {}

ProductsSort.defaultProps = {}

export default ProductsSort
